import React from 'react';
import { maxSizeDesktop, spacingExtraLarge, spacingMedium } from 'helpers/style';
import { TextMediumLarge } from 'lib/common/text';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

export const LoadingWrapper = styled.div`
    display: flex;
    position: relative;
    width: 100%;
    ${(p) => p.fullHeight && `height: 100%`};
`;
const bulging = keyframes`
  0%,
  80%,
  100% {
    box-shadow: 0 1.5em 0 -0.2em;
  }
  40% {
    box-shadow: 0 1.5em 0 0;
  }
`;

const Loader = styled.div`
    font-size: 10px;
    position: relative;
    text-indent: -9999em;
    transform: translateZ(0);
    animation-delay: -0.16s;
    border-radius: 50%;
    width: 5px;
    height: 5px;
    animation-fill-mode: both;
    animation: ${bulging} 1.8s infinite ease-in-out;
    color: ${(p) => p.theme.color.grayLight3};
    top: -20px;
    &:before,
    &:after {
        border-radius: 50%;
        width: 5px;
        height: 5px;
        animation-fill-mode: both;
        animation: ${bulging} 1.8s infinite ease-in-out;
        content: '';
        position: absolute;
    }
    &:before {
        left: -1em;
        animation-delay: -0.32s;
    }
    &:after {
        left: 1em;
    }
`;
// z-index, has to be more than content, but less than header dropdown menus and datepicker
export const LoadingOverlay = styled.div`
    position: absolute;
    text-align: center;
    background: ${(p) => p.theme.color.blackAlpha75};
    width: 100%;
    height: 100%;
    z-index: 9;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
`;

export const ErrorText = styled(TextMediumLarge)`
    color: ${(p) => p.theme.color.red};
    border: 1px solid ${(p) => p.theme.color.redDark};
    background-color: black;
    border-radius: ${(p) => p.theme.borderRadius.medium};

    padding: ${spacingExtraLarge};
    ${maxSizeDesktop} {
        padding: ${spacingMedium};
    }
`;

export const Loading = () => (
    <LoadingOverlay data-testid="loading-overlay">
        <Loader>...</Loader>
    </LoadingOverlay>
);
export const ErrorOverlay = ({ errorText }) => (
    <LoadingOverlay>
        <ErrorText title={errorText}>Error loading from API</ErrorText>
    </LoadingOverlay>
);
